const beginChangingExpandNode = (
  prevState,
  { treeId, nodeId, expanded, plugins },
) => {
  const treeState = prevState[treeId];
  if (!treeState) {
    return prevState;
  }

  const { expansion } = plugins;
  if (!expansion) {
    return prevState;
  }

  if (expansion.nodeIsExpanded(treeState, nodeId) === expanded) {
    return prevState;
  }

  return {
    ...prevState,
    [treeId]: expansion.beginChangingExpansion(
      treeState,
      nodeId,
      expanded,
      plugins,
    ),
  };
};
export default beginChangingExpandNode;
